import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Table = styled.table`
  border-radius: 10px;
  background: ${(props) => props.theme.color.light.default};
  width: 100%;
  table-layout: auto;
  border-collapse: collapse;
`;

export const TableRow = styled.tr`
  cursor: pointer;
  &:hover {
    background: ${(props) => props.theme.color.light.tint};
  }
  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.color.light.tint};
  }
`;

export const TableHeaderRow = styled.tr`
  border-bottom: 1px solid ${(props) => props.theme.color.light.shade};
`;

export const TableCell = styled.td`
  color: ${(props) => props.theme.color.dark.default};
  padding: 10px 20px;
  ${mediaQuery('medium')} {
    padding: 10px 5px;
  }
  font-size: 16px;
`;

export const TableHeaderCell = styled(TableCell)<{ width?: number }>`
  color: ${(props) => props.theme.color.medium.tint};
  width: ${(props) => (props.width ? `${props.width}px` : 'auto')};
  ${mediaQuery('medium')} {
    width: auto !important;
  }
`;

export const NameSpan = styled.div`
  font-weight: 700; ;
`;

export const Tag = styled.div`
  border-radius: 90px;
  background: ${(props) => props.theme.color.light.tint};
  padding: 4px 15px;
  width: min-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MessageIconWrapper = styled.div`
  padding: 4px 15px;
  border-radius: 90px;
  background: ${(props) => props.theme.color.blue.default};
  color: ${(props) => props.theme.color.light.default};
  display: inline-flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const MessageTag = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  border-radius: 100%;
  background: ${(props) => props.theme.color.red.default};
  color: ${(props) => props.theme.color.light.default};
  font-weight: 700;
  font-size: 11px;
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
